import React from 'react';
import { useSelector } from 'react-redux';

function GlobalNavFooter() {
  const footerHtml = useSelector(
    (state) => state?.application?.globalNavFooterHtml
  );

  return (
    <>
      {footerHtml && (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: footerHtml,
            }}
          />
        </>
      )}
    </>
  );
}

export default GlobalNavFooter;
